import { partition } from 'lodash';
import { Abnormality, Definition, Modifier } from '../types/diagnostic';
import { PRIMARY_LABELS_CONFIG } from './primary-labels.util';

export const separateAbnormalities = (
  allAbnormalities: Abnormality[],
): [Abnormality[], Abnormality[]] => {
  const primaryCodes = Object.keys(PRIMARY_LABELS_CONFIG);
  return partition(allAbnormalities, (abnormality) =>
    primaryCodes.includes(abnormality.code),
  );
};

export const separateDefinitions = (
  allDefinitions: Definition[],
): [Definition[], Definition[]] => {
  const primaryCodes = Object.keys(PRIMARY_LABELS_CONFIG);
  return partition(allDefinitions, (abnormality) =>
    primaryCodes.includes(abnormality.code),
  );
};

export const definitionsToAbnormalities = (
  definitions: Definition[],
): Abnormality[] =>
  definitions.map((definition) => ({
    ...definition,
    temporality: null,
    frequency: null,
    likelihood: null,
    localization: null,
  }));

export const hasModifiers = (definition: Pick<Definition, Modifier>) =>
  [
    definition.likelihood,
    definition.frequency,
    definition.temporality,
    definition.localization,
  ].some((modifier) => modifier != null);
